export default __webpack_public_path__ + "static/media/54_Random_Alpha.4b80b09f.mp4";